import find from 'lodash/find';
import { isUnknownObject } from 'app/utils/object';
import { tFunctionType } from 'app/components/localization';

export * from 'app/utils/errors/next';

export const formatGenericError = (error: unknown): string => {
  try {
    return error instanceof Error ? error.message
      : (isUnknownObject(error) && typeof error.detail === 'string') ? error.detail
      : JSON.stringify(error, null, 2);
  } catch (e) {
    return String(error);
  }
};

export const formatResponseErrorStatus = (responseError: { status: string, statusText: string }) =>
  `(${responseError.status}) ${responseError.statusText}`;

/**
 * Converts error events to errors.
 */
export const eventToError = (input: unknown): Error => {
  const e: { [key: string]: unknown } = isUnknownObject(input) ? input : {};

  if (e.error instanceof Error) {
    return e.error;
  } else {
    // If the browser didn't pass us the error object, make a fake error object with a fake
    // stack trace.

    // simulate v8 stack (Copied from honeybadger-js source).
    const stack = [
      e.message || '',
      '\n    at ? (',
      e.filename || 'unknown', ':',
      e.lineno || 0, ':',
      e.colno || 0,
      ')',
    ].join('');

    return {
      name: 'Error',
      message: typeof e.message === 'string' ? e.message : '',
      stack,
    };
  }
};

/**
 * Creates a function that will match known errors to appropriate
 * messages.
 */
export const errorMessageMatcher = (messages: IMatcher[]) => (t: tFunctionType, error: unknown) => {
  const match = find(messages, ({ check }) => check(error));
  if (match) {
    return match.getMessage(t, error);
  } else {
    return (isUnknownObject(error) && typeof error.message === 'string') ? error.message : null;
  }
};

interface IMatcher {
  // Function that returns true if provides message for a given `error`
  check: (error: unknown) => boolean;
  // Function that formats the `error`
  getMessage: (t: tFunctionType, error: unknown) => string | null;
}
